import { render, staticRenderFns } from "./depositMessage.vue?vue&type=template&id=13c85936&scoped=true&"
import script from "./depositMessage.vue?vue&type=script&lang=js&"
export * from "./depositMessage.vue?vue&type=script&lang=js&"
import style0 from "./depositMessage.vue?vue&type=style&index=0&id=13c85936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c85936",
  null
  
)

export default component.exports